import { Component } from '@angular/core';

@Component({
  selector: 'app-landing-terms-conditions',
  templateUrl: './landing-terms-conditions.component.html',
  styleUrls: ['../landing/landing.component.scss', './landing-terms-conditions.component.scss']
})
export class LandingTermsConditionsComponent {

}
